<div class="fuse-card">
    <div class="p-16">
        <div class="altura-titulo">
            <div class="h2 text-bold primary-fg">
                <mat-icon
                    *ngIf="tarjeta.requiereAccion && tarjeta.cantidad > 0"
                    class="red-fg"
                >
                    warning</mat-icon
                >
                {{ tarjeta?.titulo | uppercase }}
            </div>
            <div class="h5 secondary-text">{{ tarjeta?.subtitulo }}</div>
        </div>
        <div
            class="
                altura-body
                font-size-54 font-weight-300
                line-height-1
                mt-8
                text-center
            "
        >
            <span
                [ngClass]="{
                    'red-fg': tarjeta.requiereAccion && tarjeta.cantidad > 0
                }"
            >
                {{ tarjeta.cantidad }}
            </span>
        </div>
    </div>

    <!--<div class="p-16 pt-0">
                <span class="accent-fg">+12.3%</span>
                of target
            </div>-->

    <mat-divider></mat-divider>
    <div class="text-center">
        <a
            mat-button
            [routerLink]="tarjeta.ruta.url"
            [queryParams]="tarjeta.ruta.queryParams"
        >
            <mat-icon>keyboard_arrow_right</mat-icon>
            <strong>{{ tarjeta.ruta.nombre }}</strong>
        </a>
    </div>
</div>
